import { formatLocalDate } from '../utils/localDateTime';
import { confirmApp } from '../common/appDialog';
/**
 * DevImplementationDashboard.tsx
 * TEMPORARY — 19-Day Implementation Sprint Tracker
 * Remove this file and its route in App.tsx after August 22, 2026.
 * Accessible only to: insights@inteloptics.org (platform owner)
 */

import React, { useState, useEffect } from 'react';

// ─── Data ────────────────────────────────────────────────────────────────────

const PLAN = [
  {
    week: 1, label: 'Week 1 — Gemini Upgrade', color: '#EF4444', bg: '#3B0F0F',
    days: [
      { day: 1, date: 'Mon Aug 4', focus: 'Gemini Benchmark', tasks: [
        'Run routine benchmark: Flash-Lite routing across 5 country prompts',
        'Run high-capability benchmark: Gemini 3.5 Flash across 5 prompts',
        'REVIEW: Compare outputs — confirm quality parity or flag regressions',
      ], gate: 'Benchmark results reviewed and approved' },
      { day: 2, date: 'Tue Aug 5', focus: 'Flash Upgrade → Staging', tasks: [
        'Update 7 Flash file references (batchHandler, geminiService_impl, GenerateContent, firebaseConfig, verifySignal, iranTrigger, logic)',
        'Deploy functions + hosting to staging',
        'Trigger manual countryAnalysisWorker for 10 test countries',
        'WAIT: Nightly scheduler fires at 1 AM — leave running overnight',
      ], gate: null },
      { day: 3, date: 'Wed Aug 6', focus: 'Flash Validated + Pro Upgrade', tasks: [
        'REVIEW: Overnight batch results — 10 country sample. Sign off',
        'Update Pro model references in geminiService_impl routing + DailyAnalysis.ts',
        'Deploy Pro upgrade to staging',
        'REVIEW: Run 3 high-cap workflows on staging (country analysis, EP threat, integrated intel)',
        'Fix any issues from review. Redeploy',
      ], gate: 'Both Flash and Pro validated on staging' },
      { day: 4, date: 'Thu Aug 7', focus: 'Production Deployment', tasks: [
        'Deploy Flash + Pro upgrades to PRODUCTION',
        'Monitor initial Cloud Function logs',
        'REVIEW: Run 3–5 real workflows in production — confirm clean output',
        'Monitor error logs — 48-hour monitoring window begins',
      ], gate: 'Gemini upgrade live in production' },
      { day: 5, date: 'Fri Aug 8', focus: 'Monitor + Phase 1 Foundation', tasks: [
        'Review 24-hour Gemini production logs — confirm clean',
        'Update @types: regional_consultant, global_director roles, new Page values, collection interfaces',
        'Update firestore.rules: new role helpers + collection rules for regional_assignments, work_orders, consultant_activity_log',
        'Deploy updated Firestore rules',
      ], gate: 'Gemini fully validated · Phase 1 data model deployed' },
    ]
  },
  {
    week: 2, label: 'Week 2 — GMD Foundation & RCD Build', color: '#F59E0B', bg: '#2A1E0A',
    days: [
      { day: 6, date: 'Sat Aug 9', focus: 'Phase 1 Testing + Region Seed', tasks: [
        'Test Firestore rules in Emulator — confirm consultant cannot read unassigned orgs',
        'Fix any rule gaps found',
        'Seed regional_assignments Firestore docs for all 3 regions',
        'Create test regional_consultant user account',
      ], gate: 'Firestore rules validated · Test consultant account ready' },
      { day: 7, date: 'Sun Aug 10', focus: 'Phase 2 — GMD Regional Tab Part 1', tasks: [
        'Add Regional tab to SuperAdminDashboard.tsx',
        'Build consultant cards: name, location, portfolio size, last login, active work orders, reports (30d)',
        'Build portfolio assignment panel: assign/unassign orgs to consultants',
        'Wire assignment panel to regional_assignments Firestore collection',
      ], gate: null },
      { day: 8, date: 'Mon Aug 11', focus: 'Phase 2 — GMD Regional Tab Complete + Test', tasks: [
        'Add cross-region work order queue view to Regional tab',
        'Deploy to staging',
        'REVIEW: Log in as insights@inteloptics.org — review tab, test assignment panel',
        'Fix all issues from review. Redeploy',
      ], gate: 'GMD Regional tab working and approved' },
      { day: 9, date: 'Tue Aug 12', focus: 'Phase 3 — RCD Region Header + Portfolio Grid', tasks: [
        'Build RegionalConsultantDashboard.tsx: region command header with KPI strip',
        'Build portfolio client cards grid with org data fetching',
        'Wire portfolio cards: org tier, audit scores, SRM project count, open work orders',
      ], gate: null },
      { day: 10, date: 'Wed Aug 13', focus: 'Phase 3 — RCD Work Orders + Intel Feed', tasks: [
        'Build Work Orders management panel: filter by status/priority, inline status updates, consultant notes',
        'Add Regional Intelligence Feed: GlobalLiveNewsGrid scoped to coverage countries',
        'Update App.tsx routing: regional_consultant role → RCD as home page',
        'Update Header.tsx for new role. Deploy to staging',
      ], gate: null },
      { day: 11, date: 'Thu Aug 14', focus: 'Phase 3 — RCD Testing + Fixes', tasks: [
        'REVIEW: Log in as test regional_consultant — review RCD home, portfolio cards, work orders, intel feed',
        'Fix all issues found. Redeploy',
        'Second review round — confirm all panels working',
      ], gate: 'RCD fully functional and approved' },
      { day: 12, date: 'Fri Aug 15', focus: 'Phase 4 — Client Features', tasks: [
        'Add Account Manager card to OrganizationDashboard.tsx',
        'Card reads assignedConsultantId — displays consultant name, region, location, email',
        'Build WorkOrderModal.tsx: form with type, subject, description, priority fields',
        'Wire modal to submit to work_orders Firestore collection. Deploy to staging',
      ], gate: null },
    ]
  },
  {
    week: 3, label: 'Week 3 — Cloud Functions, Final Assembly & Launch', color: '#22C55E', bg: '#0F2A1E',
    days: [
      { day: 13, date: 'Sat Aug 16', focus: 'Phase 4 Test + Phase 5 Auto-Assignment', tasks: [
        'REVIEW: Log in as client — confirm consultant card shows. Submit test work order. Confirm in RCD',
        'Build assignConsultantTrigger.ts Cloud Function: hqCountry → region map → write consultant onto org doc',
        'Deploy auto-assignment Cloud Function',
      ], gate: 'Client → Consultant work order flow validated' },
      { day: 14, date: 'Sun Aug 17', focus: 'Phase 5 Test + Phase 6 Email Notifications', tasks: [
        'Test auto-assign: create org with hqCountry: NG → confirm Lagos consultant assigned',
        'Test 3 more countries across all 3 regions',
        'Build workOrderTrigger.ts: Firestore trigger → email notification to consultant on new work order',
        'Deploy + test: submit work order → confirm email received by consultant',
      ], gate: 'Auto-assignment + email notifications validated' },
      { day: 15, date: 'Mon Aug 18', focus: 'Phase 7 — GMD Billing + Onboarding Tabs', tasks: [
        'Add billing tab to GMD: MRR summary, tier breakdown, at-risk accounts, 30-day signup graph',
        'Add onboarding tab to GMD: client pipeline kanban (Trial→Active→Business→Agency)',
        'Add industry breakdown and region distribution charts to onboarding tab',
        'Deploy to staging',
      ], gate: null },
      { day: 16, date: 'Tue Aug 19', focus: 'Phase 7 Review + Matrix/Element Guide', tasks: [
        'REVIEW: GMD Billing + Onboarding tabs — report issues',
        'Fix all issues. Redeploy',
        'Write Matrix/Element GCP deployment guide: Docker config, channel setup, user provisioning',
      ], gate: 'All 7 phases complete on staging · Comms guide delivered' },
      { day: 17, date: 'Wed Aug 20', focus: 'Full Regression Test', tasks: [
        'GMD: all tabs (Regional, Billing, Onboarding, existing SuperAdmin tabs)',
        'RCD: portfolio grid, work orders panel, intel feed, routing',
        'Client org: Account Manager card + work order submission + status tracking',
        'Auto-assign: new org with hqCountry → correct consultant assigned',
        'Email: work order submitted → notification received by consultant',
        'Gemini: 5 workflows across Pro + Flash — confirm stable',
        'Compile punch list of remaining issues',
      ], gate: 'Full regression complete · Punch list compiled' },
      { day: 18, date: 'Thu Aug 21', focus: 'Final Fixes + Production Deployment', tasks: [
        'Fix all punch list items from regression test',
        'Deploy to PRODUCTION: all components, Cloud Functions, Firestore rules',
        'Smoke test in production: all three dashboards confirming live',
      ], gate: 'Full V1 live in production' },
      { day: 19, date: 'Fri Aug 22', focus: 'Monitoring + Consultant Onboarding', tasks: [
        'Monitor production logs: Firestore, Cloud Functions, AI calls',
        'Write consultant onboarding guide: login, RCD usage, work order management',
        'Deliver Matrix/Element setup guide to IT for GCP deployment',
        'REMOVE this dashboard component from the codebase',
      ], gate: 'ALL THREE PLANS COMPLETE · Consultants ready to onboard' },
    ]
  }
];

const STORAGE_KEY = 'inteloptics_dev_dashboard_v1';

// ─── Helpers ─────────────────────────────────────────────────────────────────

function loadState(): Record<string, boolean> {
  try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}'); }
  catch { return {}; }
}

function saveState(state: Record<string, boolean>) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }
  catch {}
}

function taskKey(day: number, taskIndex: number) { return `d${day}_t${taskIndex}`; }
function gateKey(day: number) { return `d${day}_gate`; }

const today = new Date();
const START = new Date('2026-08-04');
const currentDay = Math.max(1, Math.min(19, Math.floor((today.getTime() - START.getTime()) / 86400000) + 1));

// ─── Sub-components ───────────────────────────────────────────────────────────

const CheckBox: React.FC<{ checked: boolean; onChange: () => void; label: string; accent: string }> = ({ checked, onChange, label, accent }) => (
  <div onClick={onChange} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer', padding: '6px 0', borderRadius: '4px' }}>
    <div style={{
      width: '18px', height: '18px', minWidth: '18px', borderRadius: '4px', marginTop: '1px',
      border: `2px solid ${checked ? accent : '#475569'}`,
      background: checked ? accent : 'transparent',
      display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.15s'
    }}>
      {checked && <span style={{ color: '#fff', fontSize: '11px', lineHeight: 1 }}>✓</span>}
    </div>
    <span style={{ fontSize: '13px', color: checked ? '#64748B' : '#CBD5E1', textDecoration: checked ? 'line-through' : 'none', lineHeight: '1.4' }}>
      {label}
    </span>
  </div>
);

const DayCard: React.FC<{ day: typeof PLAN[0]['days'][0]; color: string; bg: string; state: Record<string, boolean>; onToggle: (key: string) => void }> =
  ({ day, color, bg, state, onToggle }) => {
    const totalTasks = day.tasks.length + (day.gate ? 1 : 0);
    const doneTasks = day.tasks.filter((_, i) => state[taskKey(day.day, i)]).length + (day.gate && state[gateKey(day.day)] ? 1 : 0);
    const pct = Math.round((doneTasks / totalTasks) * 100);
    const isToday = day.day === currentDay;
    const isPast = day.day < currentDay;

    return (
      <div style={{
        background: '#1E293B', borderRadius: '8px', overflow: 'hidden',
        border: isToday ? `2px solid ${color}` : '2px solid #334155',
        boxShadow: isToday ? `0 0 12px ${color}44` : 'none',
        transition: 'all 0.2s'
      }}>
        {/* Day header */}
        <div style={{ background: isToday ? bg : '#0F172A', padding: '10px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ background: color, borderRadius: '4px', padding: '2px 8px', fontSize: '11px', fontWeight: 700, color: '#fff' }}>
              DAY {day.day}
            </div>
            <span style={{ color: '#94A3B8', fontSize: '12px' }}>{formatLocalDate(day.date, day.date || '')}</span>
            {isToday && <span style={{ background: color, color: '#fff', fontSize: '10px', fontWeight: 700, padding: '1px 6px', borderRadius: '10px' }}>TODAY</span>}
            {isPast && pct === 100 && <span style={{ color: '#22C55E', fontSize: '11px' }}>✅ Complete</span>}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ width: '60px', height: '4px', background: '#334155', borderRadius: '2px' }}>
              <div style={{ width: `${pct}%`, height: '100%', background: color, borderRadius: '2px', transition: 'width 0.3s' }} />
            </div>
            <span style={{ color: color, fontSize: '11px', fontWeight: 700, minWidth: '32px' }}>{pct}%</span>
          </div>
        </div>
        {/* Focus */}
        <div style={{ padding: '8px 14px 4px', color: '#F1F5F9', fontSize: '13px', fontWeight: 600, borderBottom: '1px solid #1E293B' }}>
          {day.focus}
        </div>
        {/* Tasks */}
        <div style={{ padding: '6px 14px 8px' }}>
          {day.tasks.map((task, i) => (
            <CheckBox key={i} checked={!!state[taskKey(day.day, i)]} onChange={() => onToggle(taskKey(day.day, i))} label={task} accent={color} />
          ))}
          {day.gate && (
            <div style={{ marginTop: '8px', padding: '8px 12px', background: state[gateKey(day.day)] ? '#0F2A1E' : '#0F1629', borderRadius: '6px', border: `1px solid ${state[gateKey(day.day)] ? '#22C55E' : '#334155'}`, cursor: 'pointer' }}
              onClick={() => onToggle(gateKey(day.day))}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <div style={{ width: '20px', height: '20px', minWidth: '20px', borderRadius: '4px', border: `2px solid ${state[gateKey(day.day)] ? '#22C55E' : '#475569'}`, background: state[gateKey(day.day)] ? '#22C55E' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {state[gateKey(day.day)] && <span style={{ color: '#fff', fontSize: '12px' }}>✓</span>}
                </div>
                <span style={{ fontSize: '12px', fontWeight: 600, color: state[gateKey(day.day)] ? '#22C55E' : '#94A3B8' }}>
                  ✅ GATE: {day.gate}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

// ─── Main Component ───────────────────────────────────────────────────────────

const DevImplementationDashboard: React.FC = () => {
  const [state, setState] = useState<Record<string, boolean>>(loadState);

  const toggle = (key: string) => {
    setState(prev => {
      const next = { ...prev, [key]: !prev[key] };
      saveState(next);
      return next;
    });
  };

  // Calculate totals
  const allTasks = PLAN.flatMap(w => w.days.flatMap(d => d.tasks.map((_, i) => taskKey(d.day, i))));
  const allGates = PLAN.flatMap(w => w.days.filter(d => d.gate).map(d => gateKey(d.day)));
  const total = allTasks.length + allGates.length;
  const done = [...allTasks, ...allGates].filter(k => state[k]).length;
  const overallPct = Math.round((done / total) * 100);

  const daysComplete = PLAN.flatMap(w => w.days).filter(d => {
    const tasksOk = d.tasks.every((_, i) => state[taskKey(d.day, i)]);
    const gateOk = !d.gate || state[gateKey(d.day)];
    return tasksOk && gateOk;
  }).length;

  const daysRemaining = 19 - daysComplete;

  return (
    <div style={{ minHeight: '100vh', background: '#0F172A', color: '#F1F5F9', fontFamily: 'Inter, system-ui, sans-serif', padding: '20px' }}>

      {/* Header */}
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px', flexWrap: 'wrap', gap: '12px' }}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ background: '#EF4444', color: '#fff', fontSize: '10px', fontWeight: 700, padding: '2px 8px', borderRadius: '4px', letterSpacing: '0.05em' }}>DEV ONLY — REMOVE AUG 22</span>
            </div>
            <h1 style={{ fontSize: '22px', fontWeight: 700, color: '#F1F5F9', margin: '6px 0 2px' }}>
              IntelOptics — 19-Day Implementation Sprint
            </h1>
            <p style={{ color: '#64748B', fontSize: '13px', margin: 0 }}>August 4–22, 2026 · Gemini Upgrade + Global Management Dashboard + Regional Consultant Platform</p>
          </div>
          <button onClick={async () => { if (await confirmApp('Reset all progress?')) { localStorage.removeItem(STORAGE_KEY); setState({}); } }}
            style={{ background: '#1E293B', border: '1px solid #334155', color: '#94A3B8', padding: '8px 16px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' }}>
            Reset Progress
          </button>
        </div>

        {/* KPI Strip */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: '12px', marginBottom: '20px' }}>
          {[
            { label: 'Overall Progress', value: `${overallPct}%`, color: overallPct === 100 ? '#22C55E' : '#3882F6' },
            { label: 'Tasks Complete', value: `${done} / ${total}`, color: '#3882F6' },
            { label: 'Days Complete', value: `${daysComplete} / 19`, color: '#F59E0B' },
            { label: 'Days Remaining', value: daysRemaining.toString(), color: daysRemaining === 0 ? '#22C55E' : '#EF4444' },
            { label: 'Current Day', value: currentDay <= 19 ? `Day ${currentDay}` : 'Sprint Done', color: '#22C55E' },
            { label: 'Target Date', value: 'Aug 22, 2026', color: '#94A3B8' },
          ].map(kpi => (
            <div key={kpi.label} style={{ background: '#1E293B', borderRadius: '8px', padding: '14px 16px', border: '1px solid #334155' }}>
              <div style={{ color: '#64748B', fontSize: '11px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: '6px' }}>{kpi.label}</div>
              <div style={{ color: kpi.color, fontSize: '22px', fontWeight: 700 }}>{kpi.value}</div>
            </div>
          ))}
        </div>

        {/* Overall progress bar */}
        <div style={{ background: '#1E293B', borderRadius: '8px', padding: '16px', marginBottom: '24px', border: '1px solid #334155' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
            <span style={{ color: '#94A3B8', fontSize: '13px', fontWeight: 600 }}>Overall Sprint Progress</span>
            <span style={{ color: overallPct === 100 ? '#22C55E' : '#3882F6', fontSize: '13px', fontWeight: 700 }}>{overallPct}%</span>
          </div>
          <div style={{ height: '10px', background: '#0F172A', borderRadius: '5px', overflow: 'hidden' }}>
            <div style={{ height: '100%', width: `${overallPct}%`, background: overallPct === 100 ? '#22C55E' : 'linear-gradient(90deg, #3882F6, #06B6D4)', borderRadius: '5px', transition: 'width 0.4s ease' }} />
          </div>
          {/* Phase markers */}
          <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '6px' }}>
            <span style={{ color: '#EF4444', fontSize: '11px' }}>🔴 Days 1–5: Gemini</span>
            <span style={{ color: '#F59E0B', fontSize: '11px' }}>🟡 Days 6–17: GMD & RCD</span>
            <span style={{ color: '#22C55E', fontSize: '11px' }}>🟢 Days 18–19: Launch</span>
          </div>
        </div>

        {/* Weeks */}
        {PLAN.map(week => {
          const weekTasks = week.days.flatMap(d => d.tasks.map((_, i) => taskKey(d.day, i)));
          const weekGates = week.days.filter(d => d.gate).map(d => gateKey(d.day));
          const weekTotal = weekTasks.length + weekGates.length;
          const weekDone = [...weekTasks, ...weekGates].filter(k => state[k]).length;
          const weekPct = Math.round((weekDone / weekTotal) * 100);

          return (
            <div key={week.week} style={{ marginBottom: '28px' }}>
              {/* Week header */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '14px', padding: '12px 16px', background: week.bg, borderRadius: '8px', border: `1px solid ${week.color}44` }}>
                <div style={{ flex: 1 }}>
                  <span style={{ color: week.color, fontSize: '15px', fontWeight: 700 }}>{week.label}</span>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                  <div style={{ width: '120px', height: '6px', background: '#0F172A', borderRadius: '3px' }}>
                    <div style={{ width: `${weekPct}%`, height: '100%', background: week.color, borderRadius: '3px', transition: 'width 0.3s' }} />
                  </div>
                  <span style={{ color: week.color, fontSize: '13px', fontWeight: 700, minWidth: '36px' }}>{weekPct}%</span>
                  <span style={{ color: '#64748B', fontSize: '12px' }}>{weekDone}/{weekTotal} tasks</span>
                </div>
              </div>

              {/* Day cards grid */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))', gap: '12px' }}>
                {week.days.map(day => (
                  <DayCard key={day.day} day={day} color={week.color} bg={week.bg} state={state} onToggle={toggle} />
                ))}
              </div>
            </div>
          );
        })}

        {/* Footer */}
        <div style={{ background: '#1E293B', borderRadius: '8px', padding: '14px 18px', border: '1px solid #334155', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
          <span style={{ color: '#64748B', fontSize: '12px' }}>Progress auto-saved to localStorage · Reset button clears all progress</span>
          <span style={{ color: '#EF4444', fontSize: '12px', fontWeight: 600 }}>⚠ Remove this component and its App.tsx route after August 22, 2026</span>
        </div>
      </div>
    </div>
  );
};

export default DevImplementationDashboard;
